import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BackendModule } from '@shared/datastore/core';
import { userRecentProjectsAndContestsBackend } from './user-recent-projects-and-contests.backend';
import { userRecentProjectsAndContestsReducer } from './user-recent-projects-and-contests.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      'userRecentProjectsAndContests',
      userRecentProjectsAndContestsReducer,
    ),
    BackendModule.forFeature(
      'userRecentProjectsAndContests',
      userRecentProjectsAndContestsBackend,
    ),
  ],
})
export class DatastoreUserRecentProjectsAndContestsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/user-recent-projects-and-contests/user-recent-projects-and-contests.module.ts